import { render, staticRenderFns } from "./Game4-7.vue?vue&type=template&id=6cd61fd4&scoped=true&"
import script from "./Game4-7.vue?vue&type=script&lang=js&"
export * from "./Game4-7.vue?vue&type=script&lang=js&"
import style0 from "./Game4-7.vue?vue&type=style&index=0&id=6cd61fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd61fd4",
  null
  
)

export default component.exports